import CrossIcon from 'assets/img/cross.svg'
import {
  GetNumberWindow,
  IOnlineProps,
  VerifyEmailModal,
  WelcomeModal,
  withPlusUserListenerConsumer,
  withUserListenerConsumer
} from 'components'
// import { ConnectionProblemModal, withOnlineDetectConsumer } from 'components'
import { withChildListenerConsumer } from 'components/ChildListener'
import { IChildListenerContext } from 'components/ChildListener/context'
import { IUserListenerContext } from 'components/UserListener/context'
import { authRef } from 'config'
import { IChild } from 'data/child'
import firebase from 'firebase/app'
import { isEqual } from 'lodash'
// import * as mixpanel from 'mixpanel-browser'
import * as moment from 'moment'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { bindActionCreators, compose } from 'redux'
import { _route } from 'routes/config'
import SnackbarService from 'services/snackbars'
import * as PatientsActions from 'store/patients/actions'
import * as UsersActions from 'store/user/actions'
import { IRole } from 'types/database/users/user'
import Logo from '../../assets/img/logo.svg'
import Content from './content'

import { Dialog } from '@material-ui/core'
import ReactSVG from 'react-svg'
import './style.scss'

interface IContextProps {
  childListenerContext: IChildListenerContext
  userListenerContext: IUserListenerContext
  onlineContext: IOnlineProps
}

interface IProps extends RouteComponentProps, IContextProps {
  authData?: any
  user?: any
  PatientsLib?: any
  UserLib?: any
  FormsLib?: any
  patients: any
}

interface IState {
  forms: any[]
  loading: boolean
  verifyEmailModalOpen: boolean
  welcomeModalOpen: boolean
  isEmailVerified: boolean
  showConnectionProblem: boolean
  isGetNumberWindowOpen: boolean
}

export class ChildrenList extends React.Component<IProps, IState> {
  state: IState = {
    loading: false,
    forms: [],
    verifyEmailModalOpen: false,
    welcomeModalOpen: false,
    isEmailVerified: false,
    showConnectionProblem: false,
    isGetNumberWindowOpen: false
  }
  private userSignInStateObserver: firebase.Unsubscribe | null

  componentDidMount() {
    const { childListenerContext, authData, UserLib } = this.props

    // redirect to page after signIn
    if (!this.props.userListenerContext.userListener) {
      this.setState({ loading: true })

      // came back to page from another
    } else {
      const patientsIdCollect = this.props.patients.reduce(
        (_, el) => _.concat(el.patientId),
        []
      )

      const userChildrenCollect = Object.values(this.props.user.children || {})

      if (!isEqual(patientsIdCollect.sort(), userChildrenCollect.sort())) {
        this.setState({ loading: true })

        this.getChildren()
      }
    }

    // if (this.props.user?.need_verify_user_in_mixpanel) {
    //   mixpanel.people.set({
    //     'Is Verified': true
    //   })
    //   mixpanel.identify(this.props.authData?.uid)
    //   mixpanel.track('Verified email')
    // }
    // this.props.UserLib.needVerifyUserInMixpanel(false)

    this.props.PatientsLib.setCurrentPatient('')

    // unsubscribe and reset childListener
    if (childListenerContext?.childListener) {
      childListenerContext.childListener()
      childListenerContext.setChildListener(null)
    }

    this.userSignInStateObserver = authRef.onAuthStateChanged(
      this.setUserSignInStateObserver
    )

    if (authData && authData.isGetPhoneNumber) {
      this.openGetNumberWindow()
      UserLib.setIsGetPhoneNumber(false)
    } else {
      this.emailVerificationCheck(authData)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      user: prevUserdata,
      // onlineContext: { online: prevOnline },
      userListenerContext: { userListener: prevUserListener }
    } = prevProps
    const {
      user: currUserdata,
      // onlineContext: { online: currOnline },
      userListenerContext: { userListener: currUserListener }
    } = this.props

    /* 
      if (currOnline && prevOnline === false && !this.state.isEmailVerified) {
        //unsubscribe observer
        this.userSignInStateObserver?.()

        this.userSignInStateObserver = authRef.onAuthStateChanged(
          this.setUserSignInStateObserver
        )
      }
    */

    if (currUserListener && !prevUserListener) {
      this.getChildren()
    }

    if (currUserListener) {
      // use here currUserdata for preventing excute this condition during logOut on this page
      if (
        currUserdata &&
        (prevUserdata?.children !== currUserdata?.children ||
          prevUserdata?.pupils !== currUserdata?.pupils)
      ) {
        this.setState({ loading: true })

        this.getChildren()
      }
    }
  }

  componentWillUnmount() {
    // unsubscribe observer
    this.userSignInStateObserver?.()
  }

  setUserSignInStateObserver = (signedUser): void => {
    // only if user is singIn, not signOut (because it's observer)

    if (signedUser && this.props.user?.role === IRole.parent) {
      authRef.currentUser?.reload().then(() => {
        const isEmailVerified = !!signedUser?.emailVerified

        this.setState({ isEmailVerified })

        if (isEmailVerified) {
          if (!this.props.user?.children) {
            this.setState({ welcomeModalOpen: true })

            // mixpanel.people.set({
            //   'Is Verified': true
            // })
            // mixpanel.identify(signedUser.uid)
          }
        } else {
          /*
            this.setState({
              verifyEmailModalOpen: true
            })
            this.sendVerificationEmail()
          */
        }
      })
    }
  }

  emailVerificationCheck(authData) {
    if (
      authData &&
      !authData.isSendVerificationEmail &&
      !authData.emailVerified &&
      this.props.user?.role === IRole.parent
    ) {
      this.setState({
        verifyEmailModalOpen: true
      })
      this.sendVerificationEmail()
    }
  }

  getChildren = () => {
    this.props.PatientsLib.getPatients(
      childrenList => {
        this.setState({ loading: false })
        SnackbarService.close()
      },
      error => {
        this.setState({ loading: false })
        SnackbarService.showSnackbar(error, 'error')
        console.log('error', error)
        this.props.history.replace(_route.login)
      }
    )
  }

  openDetails = (childData: any): void => {
    this.props.history.push(_route.abilities(childData.patientId))
  }

  getChildrenList = (search?: string): IChild[] => {
    const { patients } = this.props
    let allChildren: IChild[] = patients.map(child => ({
      childrenName: child?.first_name,
      childrenAge: moment().diff(moment.unix(child.birth_date), 'years'),
      childrenPhoto: child.patient_avatar,
      patientId: child.patientId,
      childrenGender: child.gender,
      assessments: child.assessments,
      metaInfo: child.metaInfo && {
        ...child.metaInfo,
        birth_date: child.birth_date
      }
    }))
    if (search) {
      allChildren = allChildren.filter(
        child => child.childrenName.toLowerCase().indexOf(search) !== -1
      )
    }
    return allChildren
  }

  deleteChild = (id: string) => {
    const { PatientsLib, UserLib } = this.props
    // if (!online) {
    //   SnackbarService.showSnackbar('Internet connection problem', 'error', true)
    // }
    this.setState({ loading: true })
    PatientsLib.deleteChild(
      id,
      () => SnackbarService.setKeepOpen(false),
      err => {
        if (this.props.user?.role === IRole.educator) {
          SnackbarService.showSnackbar(
            typeof err === 'string' ? err : err.message,
            'error'
          )
        }
        this.setState({ loading: false })
      }
    )
    if (this.props.user?.role === IRole.parent) {
      UserLib.deleteChild(id)
    }
  }

  sendVerificationEmail = () => {
    const { UserLib } = this.props

    UserLib.sendVerificationEmail()
  }

  getOobCode(): string | null {
    return new URLSearchParams(this.props.location.search).get('oobCode')
  }

  childAddClicked = (): void => {
    const {
      // onlineContext: { online },
      history
    } = this.props

    // if (online) {
    /* 
        authRef.currentUser?.emailVerified
        ? this.props.history.push(_route.child.add)
        : this.setState({ verifyEmailModalOpen: true })
    */

    history.push(_route.child.add)
    // } else {
    //   this.setState({ showConnectionProblem: true })
    // }
  }

  resendEmail = () => {
    this.props.UserLib.sendVerificationEmail()
    SnackbarService.showSnackbar(
      'We sent you a new verification email. It may take up to 3 minutes to arrive. Please also check your spam folder',
      'info',
      true
    )
  }

  openGetNumberWindow = () => {
    this.setState({
      isGetNumberWindowOpen: true
    })
  }

  closeGetNumberWindow = (callback?: () => void) => {
    this.setState(
      {
        isGetNumberWindowOpen: false
      },
      callback
    )
  }

  getNumberModal = (isGetNumberWindowOpen, authData) => {
    const onClose = () =>
      this.closeGetNumberWindow(() => this.emailVerificationCheck(authData))

    return (
      <Dialog open={isGetNumberWindowOpen && !!authData} fullScreen={true}>
        <div className="get-number-popup">
          <img src={Logo} className="logo-size" />
          <div className="company-name light-font-weight">
            <span className="extra-bold">Giant</span>
            Leap
          </div>
          <GetNumberWindow
            parentId={authData && authData.uid}
            isUserForwardFromHeader={true}
            onClose={onClose}
          />
        </div>
        <div className="cross-icon" onClick={onClose}>
          <ReactSVG src={CrossIcon} />
        </div>
      </Dialog>
    )
  }

  render() {
    const {
      loading,
      verifyEmailModalOpen,
      welcomeModalOpen,
      isGetNumberWindowOpen
    } = this.state
    const { history, user: storeUser, authData } = this.props

    return (
      <>
        <Content
          childrenList={this.getChildrenList()}
          loading={loading}
          openDetails={this.openDetails}
          deletePatient={this.deleteChild}
          childAddClicked={this.childAddClicked}
          user={storeUser}
        />
        {verifyEmailModalOpen && (
          <VerifyEmailModal
            open={verifyEmailModalOpen}
            sendEmail={() => this.resendEmail()}
            onClose={() => this.setState({ verifyEmailModalOpen: false })}
            email={storeUser?.email}
            history={this.props.history}
          />
        )}
        {this.getNumberModal(isGetNumberWindowOpen, authData)}
        {welcomeModalOpen && (
          <WelcomeModal
            open={welcomeModalOpen}
            onClose={() => this.setState({ welcomeModalOpen: false })}
            onSubmit={() => history.push(_route.child.add)}
          />
        )}
        {/* {this.state.showConnectionProblem && (
          <ConnectionProblemModal online={this.props.onlineContext.online} />
        )} */}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data,
    authData: state.user.auth,
    patients: state.patients.patients
  }
}

const mapDispatchToProps = dispatch => {
  return {
    PatientsLib: bindActionCreators(PatientsActions, dispatch),
    UserLib: bindActionCreators<any, any>(UsersActions, dispatch)
  }
}

export default compose(
  withPlusUserListenerConsumer,
  withChildListenerConsumer,
  withUserListenerConsumer,
  // withOnlineDetectConsumer,
  connect(mapStateToProps, mapDispatchToProps)
)(ChildrenList)



// WEBPACK FOOTER //
// ./src/pages/ChildrenList/index.tsx